<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Import </span> /
      <span> Complete </span>
    </nav>
    <import-steps></import-steps>

    <div class="container mt-5">
      <h2 class="flow-heading my-5">Hooray! Your import was successful!</h2>

      <div class="container pt-5">
        <a class="btn btn-lg btn-outline-primary mr-2 mb-2" :href="redirectUrl">View Contacts</a>
        <a class="btn btn-lg btn-primary mb-2" href="/inventory/contacts/imports">Go to Import History</a>
      </div>
    </div>
  </div>
</template>

<script>
import ImportSteps from '../components/import/ImportSteps';

export default {
  name: 'import-complete-page',
  components: {ImportSteps},
  computed: {
    redirectUrl() {
      return window.location.search.split('contacts_href=').pop();
    },
  },
};
</script>

<style lang="scss" scoped>
.import-complete {
  &__img {
    margin: 30px auto;
  }
  &__subheading {
    font-weight: normal;
  }
}
</style>
